import { get, set } from 'lodash';
import { useEffect } from 'react';
import { useUpdateEffect } from 'ahooks';
import dayjs from 'dayjs';
import { getConf, ProjectTypeEnums, getS3Token } from '@assets/apis/base';
import { getAllReportDirec, getProjectInfo } from '@assets/apis/innovate';
import {
  getProjectInfo as getSciPjt,
  getSubject,
} from '@assets/apis/scientist';
import { useUserData } from '@components/UserData';
import { useSimpleContext } from './index';

function setDefault(obj, key, def) {
  const v = get(obj, key);
  set(obj, key, v || def);
}

const formatPersonInfo = (val) => {
  const personInfo = val.personInfo;
  (personInfo.eduInfo || []).forEach((item) => {
    if (item.endTime === '至今') {
      item.endTime = dayjs().format('YYYY-MM-DD');
    }
  });
  (personInfo.workInfo || []).forEach((item) => {
    if (item.endTime === '至今') {
      item.endTime = dayjs().format('YYYY-MM-DD');
    }
  });
  return val;
};

function getIniValuesSci(value) {
  const values = formatPersonInfo(value);
  setDefault(values, 'personInfo.eduInfo', []);
  setDefault(values, 'personInfo.workInfo', []);
  setDefault(values, 'studyInfo.paper', []);
  setDefault(values, 'studyInfo.honor', []);
  setDefault(values, 'studyInfo.patent', []);
  setDefault(values, 'studyInfo.authScientist', []);
  const p = get(values, 'studyInfo.studyAreaPath') || [];
  const recommendInfo = get(values, 'applyInfo.recommendInfo') || [];
  const researchOverviewFileKeyMap = get(values, 'applyInfo.researchOverviewFileKeyMap') || {};
  window.GreenFileKey = researchOverviewFileKeyMap;
  if (recommendInfo.length < 2) {
    for (let i = 0; i <= 2 - recommendInfo.length; i++) {
      recommendInfo.push({
        name: '',
        company: '',
        job: '',
        phone: '',
        email: '',
        letterUrl: '',
      });
    }
  }
  set(values, 'applyInfo.recommendInfo', recommendInfo);
  setDefault(
    values,
    'studyInfo.studyArea',
    p.map((t) => t.split('-').pop()),
  );
  setDefault(values, 'applyInfo.recommendInfo', []);
  if (
    get(values, 'applyInfo.isNominated') === undefined
    || get(values, 'applyInfo.isNominated') === null
  ) set(values, 'applyInfo.isNominated', false);
  const fillInType = get(values, 'applyInfo.researchOverview.fillInType');
  setDefault(values, 'applyInfo.researchOverview.fillInType', fillInType || 'onlineFillIn');
  return values;
}

function getIniValuesIno(values) {
  setDefault(values, 'additionInfo.propertyInfo', []);
  setDefault(values, 'additionInfo.honorInfo', []);
  setDefault(values, 'additionInfo.otherCredentials', []);
  setDefault(values, 'baseInfo.baseInfo', []);
  return values;
}

export function useData() {
  const { state, update } = useSimpleContext((t) => [
    t.formType,
    t.loading,
    t.disabled,
    t.step,
    t.onSubmit,
  ]);
  const { sciProjectConfigId, inoProjectConfigId } = useUserData();
  const isView = state.isViewType;
  const projectNo = state.projectNo;

  useEffect(() => {
    update((s) => (s.loading = true));
    getConf()
      .then((conf) => {
        const { projectConfDto = [] } = conf || {};
        // 项目 id 可能变化，但是 type 不会变化
        const confSci = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.SciType);
        const confIno = projectConfDto.find((t) => Number(t.type) === ProjectTypeEnums.InoType);
        const isSci = state.formType === 'scientist';
        const projectConfigId = isSci ? confSci?.id : confIno?.id;
        Promise.all([
          getProjectInfo(isView ? { projectNo } : { projectConfigId }),
          getS3Token(),
          isSci && getAllReportDirec({ projectConfigId: confSci?.id }),
          !isSci && getAllReportDirec({ projectConfigId: confIno?.id }), // ??
          getSubject({ type: 1 }),
          getSubject(),
        ])
          .then(([detail, token, sciDic, dic, subjects, sub2]) => {
            if (isSci && detail?.personInfo?.birthday === '') {
              //TODO: 原代码有问题
              sciValues.personInfo.birthday = '1990-01-01';
            }
            update((t) => {
              if (!isSci && detail.status === 9) {
                t.hasSubmit = true;
                t.disabled = true;
                t.submitType = 'innovate';
                t.formType = 'innovate';
              }
              if (isSci && detail.status === 9) {
                t.hasSubmit = true;
                t.disabled = true;
                t.submitType = 'scientist';
                t.formType = 'scientist';
              }
              if (isView) {
                t.disabled = true;
              }
              t.innovate.iniValues = isSci ? null : getIniValuesIno(detail);
              t.scientist.iniValues = isSci ? getIniValuesSci(detail) : null;
              t.innovate.projectDict = dic?.directions || [];
              t.scientist.topics = sciDic?.directions || [];
              t.scientist.subjects = subjects || [];
              t.scientist.subjects2 = sub2 || [];
              t.token = token;
              t.projectNo = detail.projectNo;
              t.recommendUploadStatus = detail.recommendUploadStatus;
            });
          })
          .finally(() => {
            update((t) => (t.loading = false));
          });
      })
      .finally(() => {
        update((t) => (t.loading = false));
      });
  }, []);

  useUpdateEffect(
    () => {
      if (state.isViewType || state.disabled || state.hasSubmit) {
        return;
      }
      const isSci = state.formType === 'scientist';
      Promise.all([
        getProjectInfo(
          isView
            ? { projectNo }
            : { projectConfigId: isSci ? sciProjectConfigId : inoProjectConfigId },
        ),
      ]).then(([detail]) => {
        if (isSci && detail?.studyInfo?.paper === null) {
          detail.studyInfo.paper = [
            {
              nation: '',
              type: '',
              name: '',
              rank: '',
              fileNumber: '',
              fileUrl: '',
            },
          ];
        }
        update((t) => {
          if (detail.status === 9) {
            t.hasSubmit = true;
            t.disabled = true;
          }
          t.innovate.iniValues = !isSci && getIniValuesIno(detail);
          t.scientist.iniValues = isSci && getIniValuesSci(detail);
        });
      });
    },
    [state.step, state.onSubmit, state.formType],
  );

  return { loading: state.loading };
}

export function useStep() {
  const { state, update } = useSimpleContext((t) => [t.step]);
  const { sciProjectConfigId, inoProjectConfigId } = useUserData();

  function refreshValues() {
    return new Promise((resolve) => {
      if (state.formType === 'innovate') {
        getProjectInfo({ projectConfigId: inoProjectConfigId }).then((res) => {
          update((t) => {
            t.innovate.iniValues = res;
          });
          resolve();
        });
      } else {
        getSciPjt({ projectConfigId: sciProjectConfigId }).then((res) => {
          update((t) => {
            t.scientist.iniValues = res;
          });
          resolve();
        });
      }
    });
  }

  function setStep(newStep) {
    if (newStep !== state.step) {
      if (state.hasSubmit) {
        update((t) => {
          t.step = newStep;
        });
        return Promise.resolve(true);
      } else {
        return refreshValues().then(() => {
          update((t) => {
            t.step = newStep;
          });
        });
      }
    }
    return Promise.resolve(true);
  }

  return { setStep, step: state.step };
}
